// extracted by mini-css-extract-plugin
export var productImage = "_pu-0";